class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartData = null;
    this.onDocumentKey = (event) => { if (event.key === 'Escape') this.close(); };
    this.onClick = (event) => {
      const close = event.target.closest('[data-starys-cart-close]');
      if (close) this.close();
      const action = event.target.closest('[data-starys-cart-action]');
      if (action) this.changeQuantity(Number(action.dataset.index), Number(action.dataset.quantity));
    };
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onDocumentKey);
    this.onDocumentClick = (event) => {
      const cartLink = event.target.closest('#cart-icon-bubble');
      if (!cartLink) return;
      event.preventDefault();
      this.open(cartLink);
    };
    document.addEventListener('click', this.onDocumentClick);
    this.refresh();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onDocumentKey);
    document.removeEventListener('click', this.onDocumentClick);
  }

  getSectionsToRender() {
    return [];
  }

  setActiveElement(element) {
    this.activeElement = element || null;
  }

  renderContents() {
    this.refresh().then(() => {
      this.classList.add('animate','active');
      this.lockScroll();
      this.setAttribute('aria-hidden','false');
    });
  }

  open(triggeredBy) {
    this.setActiveElement(triggeredBy);
    this.refresh().then(() => {
      this.classList.add('animate','active');
      this.lockScroll();
      this.setAttribute('aria-hidden','false');
    });
  }

  lockScroll() {
    if (this.scrollLocked) return;
    this.scrollPosition = window.scrollY;
    document.body.style.setProperty('--starys-cart-scroll-top', '-' + this.scrollPosition + 'px');
    document.documentElement.classList.add('starys-cart-open');
    document.body.classList.add('overflow-hidden', 'starys-cart-open');
    this.scrollLocked = true;
  }

  unlockScroll() {
    if (!this.scrollLocked) return;
    document.documentElement.classList.remove('starys-cart-open');
    document.body.classList.remove('overflow-hidden', 'starys-cart-open');
    document.body.style.removeProperty('--starys-cart-scroll-top');
    window.scrollTo({ top: this.scrollPosition || 0, left: 0, behavior: 'instant' });
    this.scrollLocked = false;
  }

  close() {
    this.classList.remove('active','animate');
    this.unlockScroll();
    this.setAttribute('aria-hidden','true');
  }

  async refresh() {
    try {
      const response = await fetch('/cart.js', {headers:{'Accept':'application/json'},cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      this.cartData = await response.json();
      const applied = await this.applyBlackFridayDiscount();
      this.render();
      this.updateHeaderCount();
      if (applied && window.location.pathname.replace(/\/$/, '') === (window.Shopify?.routes?.root || '/') + 'cart') window.location.reload();
      return this.cartData;
    } catch (error) {
      console.error('STARYS cart refresh:', error);
    }
  }

  async applyBlackFridayDiscount() {
    if (!this.cartData?.items?.length) return false;
    const applications = this.cartData.cart_level_discount_applications || [];
    if (applications.some(discount => discount.title.toUpperCase() === 'BF2026')) return false;
    const codes = (this.cartData.discount_codes || []).map(discount => discount.code);
    if (!codes.some(code => code.toUpperCase() === 'BF2026')) codes.push('BF2026');
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({discount: codes.join(',')})
    });
    if (!response.ok) throw new Error('discount update');
    this.cartData = await response.json();
    return (this.cartData.cart_level_discount_applications || []).some(discount => discount.title.toUpperCase() === 'BF2026');
  }

  async changeQuantity(line, quantity) {
    if (!line) return;
    const buttons = this.querySelectorAll('[data-starys-cart-action]');
    buttons.forEach((button) => button.disabled = true);
    try {
      const response = await fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line,quantity})
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'cart change');
      }
      this.cartData = await response.json();
      await this.applyBlackFridayDiscount();
      this.render();
      this.updateHeaderCount();
    } catch(error) {
      console.error('STARYS cart update:', error);
      this.renderError();
      await this.refresh();
    }
  }

  render() {
    const items = this.querySelector('[data-starys-cart-items]');
    const total = this.querySelector('[data-starys-cart-total]');
    if (!items || !total || !this.cartData) return;
    if (!this.cartData.items.length) {
      items.innerHTML='<div class="starys-cart-empty"><strong>Coșul tău este gol</strong><span>Adaugă un produs pentru a continua.</span></div>';
      total.textContent=this.money(0);
      const breakdown = this.querySelector('[data-starys-cart-discounts]');
      if (breakdown) breakdown.innerHTML = '';
      this.classList.add('is-empty');
      return;
    }
    this.classList.remove('is-empty');
    items.innerHTML=this.cartData.items.map((item,index)=> {
      const image=item.image ? `<img class="starys-cart-image" src="${item.image}" alt="${this.escape(item.product_title)}">` : '<div class="starys-cart-image"></div>';
      const variant=item.variant_title && item.variant_title !== 'Default Title' ? `<div class="starys-cart-item-variant">${this.escape(item.variant_title)}</div>` : '';
      return `<div class="starys-cart-item">
        ${image}
        <div class="starys-cart-item-info">
          <a class="starys-cart-item-title" href="${item.url}">${this.escape(item.product_title)}</a>
          ${variant}
          <div class="starys-cart-item-price">${this.money(item.final_price)}</div>
          <div class="starys-cart-item-actions">
            <div class="starys-qty">
              <button type="button" data-starys-cart-action data-index="${index+1}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Scade cantitatea">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-starys-cart-action data-index="${index+1}" data-quantity="${item.quantity+1}" aria-label="Crește cantitatea">+</button>
            </div>
            <button type="button" class="starys-remove" data-starys-cart-action data-index="${index+1}" data-quantity="0">Șterge</button>
            <span class="starys-cart-line-total">${this.money(item.final_line_price)}</span>
          </div>
        </div>
      </div>`;
    }).join('');
    const breakdown = this.querySelector('[data-starys-cart-discounts]');
    const discounts = this.cartData.cart_level_discount_applications || [];
    if (breakdown) {
      breakdown.innerHTML = discounts.length ? '<div class="starys-cart-discount-row"><span>Subtotal produse</span><span>' + this.money(this.cartData.items_subtotal_price) + '</span></div>' + discounts.map(discount => '<div class="starys-cart-discount-row starys-cart-discount-row--saving"><span>' + 'Reducere pentru comandă<br><b>' + this.escape(discount.title) + '</b></span><strong>− ' + this.money(discount.total_allocated_amount) + '</strong></div>').join('') : '';
    }
    total.textContent=this.money(this.cartData.total_price);
  }

  renderError() {
    const items=this.querySelector('[data-starys-cart-items]');
    if(items) {
      const notice=document.createElement('div');
      notice.style.cssText='margin:12px 0;padding:10px 12px;border-radius:8px;background:#fff1f1;color:#9b2226;font-size:13px;';
      notice.textContent='Nu am putut actualiza coșul. Încearcă din nou.';
      items.prepend(notice);
    }
  }

  updateHeaderCount() {
    const bubble=document.querySelector('#cart-icon-bubble');
    if (!bubble || !this.cartData) return;
    let count=bubble.querySelector('.cart-count-bubble');
    if (this.cartData.item_count > 0) {
      if (!count) {
        count=document.createElement('div');
        count.className='cart-count-bubble';
        bubble.appendChild(count);
      }
      count.innerHTML='<span aria-hidden="true">'+this.cartData.item_count+'</span><span class="visually-hidden">Coș: '+this.cartData.item_count+' produse</span>';
    } else if (count) {
      count.remove();
    }
  }

  money(cents) {
    return new Intl.NumberFormat('ro-RO',{minimumFractionDigits:2,maximumFractionDigits:2}).format((cents||0)/100)+' lei';
  }

  escape(value) {
    return String(value||'').replace(/[&<>"']/g,(char)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  }
}
customElements.define('cart-drawer', CartDrawer);
